// extracted by mini-css-extract-plugin
export default {"mobileMenu":"MobileMenu_mobileMenu__IQhGy","closeMenu":"MobileMenu_closeMenu__1LR0r","title":"MobileMenu_title__736Zb","open":"MobileMenu_open__F-4s1"};